var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenBigEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936",
    transform: "translate(-6013 -6700)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6013 6700)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M22.861,11.584A12.807,12.807,0,0,0,11.5,4.5,12.809,12.809,0,0,0,.139,11.584a1.292,1.292,0,0,0,0,1.166A12.807,12.807,0,0,0,11.5,19.833a12.809,12.809,0,0,0,11.361-7.084A1.292,1.292,0,0,0,22.861,11.584ZM11.5,17.917a5.75,5.75,0,1,1,5.75-5.75A5.75,5.75,0,0,1,11.5,17.917Zm0-9.583a3.806,3.806,0,0,0-1.011.151,1.911,1.911,0,0,1-2.671,2.671A3.825,3.825,0,1,0,11.5,8.333Z",
    transform: "translate(6051.5 6737.833)",
    fill: "#00c4de",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye-off",
    "data-name": "Icon ionic-md-eye-off",
    d: "M13.753,8.647a5.214,5.214,0,0,1,5.23,5.189,4.992,4.992,0,0,1-.375,1.9l3.054,3.028a12.27,12.27,0,0,0,3.588-4.927A12.386,12.386,0,0,0,9.58,6.779l2.258,2.243A5.171,5.171,0,0,1,13.753,8.647ZM3.3,5.819,5.684,8.185l.482.477A12.212,12.212,0,0,0,2.25,13.837a12.4,12.4,0,0,0,16.081,6.909l.441.436,3.064,3.028,1.329-1.319L4.621,4.5Zm5.78,5.733L10.7,13.159a2.94,2.94,0,0,0-.082.672,3.121,3.121,0,0,0,3.136,3.11,2.95,2.95,0,0,0,.678-.082l1.622,1.607a5.2,5.2,0,0,1-7.53-4.64A5.127,5.127,0,0,1,9.077,11.552Zm4.507-.806,3.3,3.27.021-.164a3.121,3.121,0,0,0-3.136-3.11Z",
    transform: "translate(6049.25 6735.645)",
    fill: "#00c4de",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-eye-2",
    "data-name": "Icon awesome-eye",
    transform: "translate(6034 6725.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye-3",
    "data-name": "Icon awesome-eye",
    d: "M57.2,22.224A32.045,32.045,0,0,0,28.774,4.5,32.049,32.049,0,0,0,.348,22.225a3.232,3.232,0,0,0,0,2.916A32.045,32.045,0,0,0,28.774,42.865,32.049,32.049,0,0,0,57.2,25.14,3.232,3.232,0,0,0,57.2,22.224ZM28.774,38.069A14.387,14.387,0,1,1,43.161,23.682,14.387,14.387,0,0,1,28.774,38.069Zm0-23.978a9.522,9.522,0,0,0-2.529.379,4.781,4.781,0,0,1-6.684,6.684,9.569,9.569,0,1,0,9.213-7.063Z",
    transform: "translate(0 1.304)",
    fill: "#00c4de"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenBigEye);
export default __webpack_public_path__ + "static/media/Icon_open_big_eye.16535c801408e3b789804008a087bea6.svg";
export { ForwardRef as ReactComponent };